export const getLimit = quantity => (quantity > 30 ? 30 : quantity);

export const showSelector = (salesPrice, limit) => salesPrice <= 100 && limit >= 2;
